export default __webpack_public_path__ + "static/media/male.6dceb9e1.svg";